import { DICE_RESOLVABLE_SOURCE } from '@dicetechnology/dice-doris';
import type { MediaStatus } from 'chromecast-caf-receiver/cast.framework.messages';

export const removeResolvedSourceFromCustomData = (mediaStatus: MediaStatus): MediaStatus => {
    const { media } = mediaStatus;
    if (!media) {
        return mediaStatus;
    }

    if (media.customData?.resolutionType === DICE_RESOLVABLE_SOURCE && media.customData?.resolutionCustomData) {
        media.customData.resolutionCustomData = {
            ...media.customData.resolutionCustomData
        };
        delete media.customData.resolutionCustomData.resolvedData;
    }

    return mediaStatus;
};
